/**
 * Receives functions as arguments and returns a new function that calls all.
 */
export function chain(...fns) {
    return (...args) => {
        for (const fn of fns) {
            if (typeof fn === "function") {
                fn(...args);
            }
        }
    };
}
